export const PDF = 'pdf'
export const PPTX = 'pptx'
export const XLSX = 'xlsx'
